module.exports = __webpack_public_path__ + "img/Automated systems.09331f24.svg";